import cn from 'classnames';
import queryString from 'query-string';
import React from 'react';
import mapPinIcon from './mapPinIcon.svg';
import Meta from './Meta';

export interface Props {
  url: string;
  img: string;
  imgAlt: string;
  title: string;
  subtitle?: string;
  location?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
}

const isPlaceholder = (img: string): boolean =>
  queryString.parseUrl(img).url.endsWith('No_image-12.png');

const CharityResultCard = React.memo(
  ({ url, img, imgAlt, title, subtitle, location, onClick }: Props) => (
    <a
      href={url}
      onClick={onClick}
      className={cn(
        'jg-search-result-card--charity',
        'jg-text-no-underline@hover',
        'jg-display-flex jg-flex-column'
      )}
    >
      <div
        className={cn(
          'jg-search-result-card--charity__inner',
          'jg-background--white-smoke@hover',
          'jg-space-mxs jg-space-phsm jg-space-ptsm jg-space-pbxs',
          'jg-space-msm@md jg-space-pbsm@lg',
          'jg-br jg-bd jg-bd--very-light-grey',
          'jg-flex-g1'
        )}
      >
        <div
          className={cn(
            'jg-icon--large jg-icon--xlarge@lg jg-space-mbsm',
            'jg-bd jg-bd--gainsboro jg-background--white',
            'jg-display-flex jg-flex-aic jg-flex-jcc',
            {
              'jg-space-pxs jg-space-psm@lg': isPlaceholder(img),
            }
          )}
        >
          <img
            data-src={`${queryString.parseUrl(img).url}?template=size140x140`}
            alt={imgAlt}
            className={cn(
              'jg-search-result-card--charity__image',
              'jg-flex-g0 jg-flex-s0',
              'lazyload'
            )}
          />
        </div>

        <h3
          className={cn('jg-text--large-regular jg-color--nero jg-space-mbxs')}
        >
          {title}
        </h3>

        {subtitle && <Meta text={subtitle} />}
        {location && <Meta icon={mapPinIcon} text={location} />}
      </div>
    </a>
  )
);
export default CharityResultCard;
